import { Routes, Route } from "react-router-dom";
import { Box } from "@mui/material";
import classes from "./Dashboard.module.scss";
import Homepage from "../../pages/homepage/Homepage";
import Article from "../article/Article";
import NotFound from "../../pages/not-found/NotFound";
import { RouteNames } from "../../enums/RouteNames";
import Variation from "../variation/Variation";
import MyVariations from "../my-variations/MyVariations";
import StatisticsDashboard from "../statistics-dashboard/StatisticsDashboard";
import ProfilePage from "../../pages/profile-page/ProfilePage";
import SingleTip from "../single-tip/SingleTip";
import SingleVariationTip from "../single-variation-tip/SingleVariationTip";

const Dashboard = () => {
  return (
    <Box className={classes.container}>
      <Routes>
        <Route path={RouteNames.HOME} element={<Homepage />} />
        <Route path={RouteNames.ARTICLE} element={<Article />} />
        <Route path={RouteNames.PROFILE} element={<ProfilePage />} />
        <Route path={RouteNames.VARIATION} element={<Variation />} />
        <Route path={RouteNames.MY_VARIATIONS} element={<MyVariations />} />
        <Route path={RouteNames.STATISTICS_DASHBOARD} element={<StatisticsDashboard />} />
        <Route path={RouteNames.TIP} element={<SingleTip/>} />
        <Route path={RouteNames.TIP_VARIATION} element={<SingleVariationTip/>} />
        <Route path='/*' element={<NotFound />} />
      </Routes>
    </Box>
  );
};

export default Dashboard;
